/**
 * Browser-safe Workbench shortcut predicates.
 *
 * Ctrl/Cmd+N is reserved by browsers for opening a new window, so the page
 * cannot reliably intercept it. Alt makes the chord available to Workbench.
 */
export function isNewInvestigationShortcut(e: KeyboardEvent): boolean {
    const mod = e.ctrlKey || e.metaKey;
    const isN = e.key.toLowerCase() === 'n' || e.code === 'KeyN';
    return mod && e.altKey && !e.shiftKey && isN;
}

export type WorkbenchShortcutAction =
    | 'save'
    | 'newInvestigation'
    | 'trace'
    | 'links'
    | 'toggleFilters';

/**
 * Resolve a key event into a Workbench action.
 *
 * File-level chords remain available inside form controls. Bare letters do
 * not, so typing in the Omnibar can never trigger a canvas tool.
 */
export function getWorkbenchShortcutAction(e: KeyboardEvent): WorkbenchShortcutAction | null {
    const mod = e.ctrlKey || e.metaKey;
    const key = e.key.toLowerCase();

    if (mod && !e.altKey && !e.shiftKey && key === 's') return 'save';
    if (isNewInvestigationShortcut(e)) return 'newInvestigation';

    const el = e.target as HTMLElement | null;
    const tag = el?.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el?.isContentEditable) {
        return null;
    }
    if (mod || e.altKey) return null;

    if (key === 't') return 'trace';
    if (key === 'l') return 'links';
    if (key === 'f') return 'toggleFilters';
    return null;
}
